import { Capacitor } from '@capacitor/core'
import type { ConnectionStatus } from '@capacitor/network'
import { Network } from '@capacitor/network'
import { makeConnectionStatus } from './makeConnectionStatus'

/**
 * Only native asks the plugin. Its web implementation is `navigator.onLine` in a lazily loaded chunk, and Safari
 * keeps a failed load of that chunk across a reload (BANYAN_APP-5KV).
 */
export const getNetworkStatus = async (): Promise<ConnectionStatus> => {
  if (Capacitor.isNativePlatform()) return Network.getStatus()

  return makeConnectionStatus(navigator.onLine)
}
